import type {
	JiraProjectStyle,
	JiraProjectType,
} from '@jira/platform__project-types/src/project-types.tsx';
import type { MessageDescriptor } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export const projectTypeLabels: Record<
	JiraProjectStyle,
	Record<JiraProjectType, MessageDescriptor>
> = {
	COMPANY_MANAGED_PROJECT: {
		BUSINESS: messages.companyManagedBusiness,
		SOFTWARE: messages.companyManagedSoftware,
		SERVICE_DESK: messages.companyManagedServiceProject,
		PRODUCT_DISCOVERY: messages.productDiscoveryProject,
		CUSTOMER_SERVICE: messages.customerServiceProjectNonFinal,
	},
	TEAM_MANAGED_PROJECT: {
		BUSINESS: messages.teamManagedBusiness,
		SOFTWARE: messages.teamManagedSoftware,
		SERVICE_DESK: messages.teamManagedServiceProject,
		PRODUCT_DISCOVERY: messages.productDiscoveryProject,
		CUSTOMER_SERVICE: messages.customerServiceProjectNonFinal,
	},
};
